import { PRESENTIEL_SLOT_TYPE } from '@omecare/utils';
import { useForm } from 'react-hook-form';
import {
  AddOfficeWorkScheduleSlotFormValues,
  addOfficeWorkScheduleSlotFormResolver,
} from './schema';

export type AddOfficeWorkScheduleSlotUseForm = ReturnType<
  typeof useForm<AddOfficeWorkScheduleSlotFormValues>
>;

export const useAddOfficeWorkScheduleSlotForm = (
  defaultValues?: Partial<AddOfficeWorkScheduleSlotFormValues>,
) => {
  const addOfficeWorkScheduleSlotForm =
    useForm<AddOfficeWorkScheduleSlotFormValues>({
      resolver: addOfficeWorkScheduleSlotFormResolver,
      defaultValues: {
        periodOfTheDay: 'allday',
        slotType: PRESENTIEL_SLOT_TYPE,
        specificDates: [],
        forceWithoutAssistant: false,
        ...defaultValues,
      },
      // mode: 'all',
    });

  return { addOfficeWorkScheduleSlotForm };
};
